import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { z } from "zod";
import StockStatusTable from "@/components/inventory/stock-status-table";

const stockStatusSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  alertType: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/inventory/")({
  validateSearch: stockStatusSearchSchema,
  component: StockStatusPage,
});

function StockStatusPage() {
  const searchParams = Route.useSearch();

  return (
<RouteGuardPermissions
      permissions={[{ module: "stock", actions: ["read"] }]}>

    <div className="space-y-4">
      <StockStatusTable
        currentPage={searchParams.page}
        basePath="/inventory"
        searchParams={searchParams}
      />
    </div>

    </RouteGuardPermissions>
  );
}
